import { gql } from "@apollo/client";

const CREATE_USER_ENTITY = gql`
  mutation CreateUserEntity($args: CreateUserEntityInput!) {
    createUserEntity(args: $args) {
      _id
    }
  }
`;

const DELETE_USER_ENTITY = gql`
  mutation DeleteUserEntity($userId: ID, $userEntityId: ID, $entityId: ID) {
    deleteUserEntity(userId: $userId, userEntityId: $userEntityId, entityId: $entityId) {
      _id
    }
  }
`;

const UPDATE_USER_ENTITY = gql`
  mutation UpdateUserEntity($args: UpdateUserEntityInput!, $userEntityId: ID!) {
    updateUserEntity(args: $args, userEntityId: $userEntityId) {
      _id
    }
  }
`;

const UPDATE_ASSOCIATION_USER_ENTITY = gql`
mutation UpdateAssociationUserEntity($args: UpdateUserEntityInput!) {
  updateAssociationUserEntity(args: $args) {
    _id
    associationType
  }
}
`;
export { CREATE_USER_ENTITY, DELETE_USER_ENTITY, UPDATE_USER_ENTITY, UPDATE_ASSOCIATION_USER_ENTITY };
